Vue.component("settings", {

  mixins: [require("../../mixins/tab-state")],

  props: ["user", "team", "hasPendingDebitOrder"],

  mounted() {
    this.usePushStateForTabs(".settings-tabs");
    let url = new URL(window.location.href);
  }

});
